module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/icon_title_2-f03611241019b911a60bb0dba02f7d73.svg";